import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { addSeconds, format } from 'date-fns';

// import { Wrapper, DebugSection, DebugItem } from './styles';

const DebugOverlay = ({
  visible,
  browserSupported,
  hvcSupported,
  shakaPlayer,
  manifestLoaded,
  videoPlaying,
  streamStats,
  variantTracks,
  buffering,
  muted,
  totalTime,
  currentTime,
}) => {
  const currentDate = addSeconds(new Date(0), currentTime || 0);
  const totalDate = addSeconds(new Date(0), totalTime || 0);
  return (
    <>
      {visible && (
        <div className="Wrapper1">
          <div className="DebugSection">
            <span>General</span>
            <pre className="DebugItem" active={browserSupported}>{`Supported: ${browserSupported}`}</pre>
            <pre className="DebugItem" active={hvcSupported}>{`H.265 Supported: ${hvcSupported}`}</pre>
            <pre className="DebugItem" active={!!shakaPlayer}>{`Player Ready: ${!!shakaPlayer}`}</pre>
            <pre className="DebugItem" active={manifestLoaded}>{`Manifest Loaded: ${manifestLoaded}`}</pre>
            <pre className="DebugItem" active={videoPlaying}>{`Video Playing: ${videoPlaying}`}</pre>
            <pre className="DebugItem" active={muted}>{`Muted: ${muted}`}</pre>
          </div>

          {streamStats && (
            <div className="DebugSection">
              <span>Stream</span>
              <pre className="DebugItem">{`Playback: ${format(currentDate, 'mm:ss')}/${format(totalDate, 'mm:ss')}`}</pre>
              <pre className="DebugItem">{`Resolution: ${streamStats.width}x${streamStats.height}`}</pre>
              <pre className="DebugItem">{`Stream Bandwidth: ${streamStats.streamBandwidth / 1000000} Mbps`}</pre>
              <pre className="DebugItem">{`Current Bandwidth: ${Math.floor(streamStats.estimatedBandwidth / 1000000)} Mbps`}</pre>
              <pre className="DebugItem">{`Is Buffering: ${buffering}`}</pre>
              <pre className="DebugItem">
                {`Load Latency: ${Math.round((streamStats.loadLatency + Number.EPSILON) * 100) / 100}s`}
              </pre>
              <pre className="DebugItem">
                {`Buffering Time: ${Math.round((streamStats.bufferingTime + Number.EPSILON) * 100) / 100}s`}
              </pre>
              <pre className="DebugItem">{`Decoded Frames: ${streamStats.decodedFrames}`}</pre>
              <pre className="DebugItem">{`Dropped Frames: ${streamStats.droppedFrames}`}</pre>
              <pre className="DebugItem">{`Corrupted Frames: ${streamStats.corruptedFrames}`}</pre>
            </div>
          )}

          {variantTracks && (
            <div>
              <span>Variants</span>
              {variantTracks.map((track) => (
                <pre className="DebugItem" active={track.active} key={track.id}>
                  {`${track.height}p - ${track.videoBandwidth / 1000000} Mbps - ${track.codecs} - ${
                    Math.round((track.frameRate + Number.EPSILON) * 100) / 100
                  } fps`}
                </pre>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

DebugOverlay.propTypes = {
  visible: PropTypes.bool.isRequired,
  browserSupported: PropTypes.bool.isRequired,
  hvcSupported: PropTypes.bool.isRequired,
  shakaPlayer: PropTypes.object,
  manifestLoaded: PropTypes.bool.isRequired,
  videoPlaying: PropTypes.bool.isRequired,
  streamStats: PropTypes.object,
  variantTracks: PropTypes.array,
  buffering: PropTypes.bool.isRequired,
  muted: PropTypes.bool.isRequired,
  totalTime: PropTypes.number,
  currentTime: PropTypes.number,
};

DebugOverlay.defaultProps = {
  shakaPlayer: null,
  streamStats: null,
  variantTracks: null,
  totalTime: 0,
  currentTime: 0,
};

export default DebugOverlay;
